<template>
    <v-card :loading="loading" min-height="500" flat mx-2>
        <template slot="progress">
            <v-overlay absolute class="d-flex flex-column text-center">
                <div>
                    <v-progress-circular size="250" width="10" color="primary" indeterminate>
                        <span>In curs de incarcare...</span>
                    </v-progress-circular>
                </div>
            </v-overlay>
        </template>
        <v-container class="px-10" fluid v-if="!loading">
            <v-row>
                <v-col cols="3">
                    <v-card elevation="2">
                        <v-card-title>Detalii fisa</v-card-title>
                        <v-card-text>
                            <v-select
                                :items="(new $db.EquipmentWorksheet).types"
                                v-model="form.data.serviceType"
                                :error-messages="errorMessages('data.serviceType')"
                                :class="{ 'error--text': hasErrors('data.serviceType') }"
                                v-validate="'required'"
                                class="primary--text"
                                name="data.serviceType"
                                label="Tip serviciu"
                                data-vv-as="E-Tip serviciu"
                                data-vv-name="data.serviceType"
                            />
                            <v-combobox
                                :items="emailSuggestions"
                                v-model="form.data.email"
                                :error-messages="errorMessages('data.email')"
                                :class="{ 'error--text': hasErrors('data.email') }"
                                class="primary--text"
                                name="data.email"
                                label="E-mail"
                                data-vv-as="E-mail"
                                data-vv-name="data.email"
                                :autocomplete="`autocomplete_off_${strRandom(10)}`"
                            />
                            <v-text-field
                                v-model="form.data.contactPerson"
                                :error-messages="errorMessages('data.contactPerson')"
                                :class="{ 'error--text': hasErrors('data.contactPerson') }"
                                v-validate="'required'"
                                class="primary--text"
                                name="data.contactPerson"
                                label="Persoana de contact"
                                data-vv-as="Persoana de contact"
                                data-vv-name="data.contactPerson"
                            />
                            <v-combobox
                                :items="phoneSuggestions"
                                v-model="form.data.phone"
                                :error-messages="errorMessages('data.phone')"
                                :class="{ 'error--text': hasErrors('data.phone') }"
                                class="primary--text"
                                name="data.phone"
                                label="Telefon"
                                data-vv-as="Telefon"
                                data-vv-name="data.phone"
                                :autocomplete="`autocomplete_off_${strRandom(10)}`"
                            />
                            <v-textarea
                                v-model="form.data.remarks"
                                :error-messages="errorMessages('data.remarks')"
                                :class="{ 'error--text': hasErrors('data.remarks') }"
                                class="primary--text"
                                name="data.remarks"
                                label="Observatii interne"
                                data-vv-as="Observatii interne"
                                data-vv-name="data.remarks"
                            />
                            <v-textarea
                                v-model="form.data.client_remarks"
                                :error-messages="errorMessages('data.client_remarks')"
                                :class="{ 'error--text': hasErrors('data.client_remarks') }"
                                class="primary--text"
                                name="data.client_remarks"
                                label="Observatii client"
                                data-vv-as="Observatii client"
                                data-vv-name="data.client_remarks"
                            />
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="3">
                    <v-card elevation="2">
                        <v-card-title>Detalii client</v-card-title>
                        <v-card-text>
                            <customer-modal
                                v-model="form.customer_id"
                                :field-errors="errorMessages('customer_id')"
                                :initial-items="[form.customer]"
                                @change="(customer) => form.customer = customer"
                                :expandeable="true"
                            />
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="3">
                    <v-card elevation="2">
                        <v-card-title>Detalii echipament</v-card-title>
                        <v-card-text>
                            <equipment-modal
                                v-model="form.equipment_id"
                                :field-errors="errorMessages('equipment_id')"
                                :initial-items="[form.equipment]"
                                :customer-id="form.customer_id"
                                :autocomplete="true"
                            />
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="3">
                    <v-card elevation="2">
                        <v-card-title>Actiuni fisa</v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="12">
                                        <template v-if="!_.isNil(form.id)">
                                            <v-subheader>Generare documente</v-subheader>
                                            <v-btn
                                                v-if="!_.isNil(form.id)"
                                                block
                                                color="info"
                                                class="my-2"
                                                @click="downloadWorksheetFile"
                                            >
                                                Generare Fisa
                                            </v-btn>

                                            <v-divider class="my-4"></v-divider>
                                        </template>

                                        <v-subheader>Actiuni</v-subheader>
                                        <v-btn
                                            v-if="canEdit"
                                            :loading="form.busy"
                                            :disabled="errors.any() || form.busy"
                                            block
                                            color="success"
                                            class="my-2"
                                            @click="submit()"
                                        >
                                            <v-icon left>
                                                save
                                            </v-icon>
                                            Salveaza
                                        </v-btn>

                                        <v-btn
                                            v-if="!_.isNil(form.id) && canEdit"
                                            block
                                            color="error"
                                            class="my-2"
                                            @click="markFinalized"
                                        >
                                            Marcheaza finalizat
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col md="12">
                    <v-card elevation="2">
                        <v-card-title>Date intrare utilaj</v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col md="6">
                                    <v-text-field
                                        v-model="form.data.equipmentMileage"
                                        :error-messages="errorMessages('data.equipmentMileage')"
                                        :class="{ 'error--text': hasErrors('data.equipmentMileage') }"
                                        class="primary--text"
                                        name="data.equipmentMileage"
                                        data-vv-name="data.equipmentMileage"
                                        label="Numar ore (h) / Rulaj (km)"
                                        data-vv-as="Numar ore (h) / Rulaj (km)"
                                    />
                                    <v-radio-group
                                        v-model="form.data.equipmentFuelLevel"
                                        :error-messages="errorMessages('data.equipmentFuelLevel')"
                                        :class="{ 'error--text': hasErrors('data.equipmentFuelLevel') }"
                                        name="data.equipmentFuelLevel"
                                        data-vv-name="data.equipmentFuelLevel"
                                        label="Nivel combustibil"
                                        data-vv-as="Nivel combustibil"
                                        row
                                    >
                                        <v-radio
                                            v-for="(fuelLevel, flIndex) in (new $db.EquipmentWorksheet).fuelLevels" :key="flIndex"
                                            :label="fuelLevel.text"
                                            :value="fuelLevel.value"
                                        ></v-radio>
                                    </v-radio-group>
                                </v-col>
                                <v-col md="6">
                                    <v-textarea
                                        v-model="form.data.equipmentAccessories"
                                        :error-messages="errorMessages('data.equipmentAccessories')"
                                        :class="{ 'error--text': hasErrors('data.equipmentAccessories') }"
                                        class="primary--text"
                                        name="data.equipmentAccessories"
                                        data-vv-name="data.equipmentAccessories"
                                        label="Accessorii"
                                        data-vv-as="Accessorii"
                                    />
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                    <v-divider></v-divider>
                </v-col>
                <v-col md="6">
                    <v-card elevation="2">
                        <v-card-title>Defecte reclamate</v-card-title>
                        <v-card-text>
                            <v-textarea
                                v-model="form.data.defects"
                                :error-messages="errorMessages('data.defects')"
                                :class="{ 'error--text': hasErrors('data.defects') }"
                                class="primary--text"
                                name="data.defects"
                                data-vv-name="data.defects"
                                label="Defecte reclamate"
                                data-vv-as="Defecte reclamate"
                            />
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col md="6">
                    <v-card elevation="2">
                        <v-card-title>Solutionare</v-card-title>
                        <v-card-text>
                            <v-textarea
                                v-model="form.data.solutions"
                                :error-messages="errorMessages('data.solutions')"
                                :class="{ 'error--text': hasErrors('data.solutions') }"
                                class="primary--text"
                                name="data.solutions"
                                data-vv-name="data.solutions"
                                label="Solutionare"
                                data-vv-as="Solutionare"
                            />
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col md="6">
                    <v-card elevation="2">
                        <v-card-title>Defecte constatate</v-card-title>
                        <v-card-text>
                            <v-textarea
                                v-model="form.data.defects_identified"
                                :error-messages="errorMessages('data.defects_identified')"
                                :class="{ 'error--text': hasErrors('data.defects_identified') }"
                                class="primary--text"
                                name="data.defects_identified"
                                data-vv-name="data.defects_identified"
                                label="Defecte constatate"
                                data-vv-as="Defecte constatate"
                            />
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col md="6">
                    <v-card elevation="2">
                        <v-card-title>Solicitare inlocuire piese</v-card-title>
                        <v-card-text>
                            <v-textarea
                                v-model="form.data.spare_parts"
                                :error-messages="errorMessages('data.spare_parts')"
                                :class="{ 'error--text': hasErrors('data.spare_parts') }"
                                class="primary--text"
                                name="data.spare_parts"
                                data-vv-name="data.spare_parts"
                                label="Solicitare inlocuire piese"
                                data-vv-as="Solicitare inlocuire piese"
                            />
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>

<script>
    import CustomerModal from 'Components/modal/CustomerModal'
    import EquipmentModal from 'Components/modal/EquipmentModal'
    import validationError from "Mixins/validation-error";
    import ACL from "Mixins/acl";
    import {Form} from "vform";
    import throttle from 'lodash/throttle'
    import { createNamespacedHelpers } from "vuex";
    const { mapGetters } = createNamespacedHelpers("auth");

    export default {
        mixins: [validationError, ACL],
        components: {
            CustomerModal,
            EquipmentModal
        },
        props: {
            id: {
                type: [Number, String],
                required: false
            }
        },
        data: () => ({
            tab: 'general',
            loading: false,
            /* Always Declare Your Form Object */
            form: new Form({
                id: null,
                customer_id: null,
                equipment_id: null,
                document_no: null,
                offer_date: null,
                status: null,
                customer: {
                    summary: {
                        emails: [],
                        phones: []
                    }
                },
                equipment: null,
                created_by: null,
                data: {
                    contactPerson: null,
                    email: null,
                    phone: null,
                    remarks: null,
                    client_remarks: null,
                    defects: null,
                    solutions: null,
                    defects_identified: null,
                    spare_parts: null,
                    serviceType: null,
                    equipmentFuelLevel: null,
                    equipmentMileage: null,
                    equipmentAccessories: null
                }
            })
        }),
        computed: {
            ...mapGetters({
                getMe: "getMe"
            }),
            canEdit() {
                if ((!this._.isNil(this.form.status) && ['CANCELED', 'FINALIZED'].indexOf(this.form.status) >= 0)) return false
                if (!this._.isNil(this.form.created_by) && this.getMe?.id !== this.form.created_by && !this.hasRole('admin')) return false
                return true
            },
            emailSuggestions() {
                return this.form.customer?.summary?.emails || []
            },
            phoneSuggestions() {
                return this.form.customer?.summary?.phones || []
            }
        },
        watch: {
            'form.customer': {
                handler(val) {
                    if(val?.id) {
                        this.form.customer_id = val.id
                    }
                },
                deep: true
            },
            'form.equipment': {
                handler(val) {
                    if(val?.id) {
                        this.form.equipment_id = val.id
                    }
                },
                deep: true
            }
        },
        async mounted() {
            if(this.id) {
                await this.loadResource()
            }
        },
        methods: {
            loadResource: throttle(async function (val) {
                let self = this;
                this.loading = true;

                let { data } = await this.$db.EquipmentWorksheet
                    .include('customer', 'equipment')
                    .find(this.id)
                self.form = new Form(data)
                this.loading = false
            }, 500),
            async submit() {
                let self = this;
                this.$validator.validateAll().then(result => {
                    if (result) {
                        // eslint-disable-next-line
                        setTimeout(() => self.createOrUpdate(), 500)
                    } else {
                        this.showError()
                    }
                });
            },
            async createOrUpdate() {
                let self = this;
                self.form.busy = true;

                var model = new this.$db.EquipmentWorksheet(self.form);
                if (this.id) {
                    model.id = this.id
                }

                model.save()
                    .then(response => {
                        self.$validator.reset();
                        this.showSuccess();
                        if (this._.isNil(model.id) && response?.id) {
                            self.$nextTick(() => self.$router.push({name: "equipment-worksheet-edit", params: {id : response.id }}));
                        }
                    })
                    .catch(errors => {
                        self.form.errors.set(this.form.extractErrors(errors.response))
                        this.showError()
                    }).finally(() => {
                    self.form.busy = false;
                });
            },
            async markFinalized() {
                this.loading = true
                await axios.post(route('equipment-worksheets.set-status', {
                    workstation: this.form.workstation_id,
                    sheetId: this.form.id,
                    status: 'FINALIZED'
                })).then(async () => {
                    await this.loadResource()
                }).finally(() => {
                    this.loading = false
                })
            },
            async downloadWorksheetFile() {
                const downloadEndpoint = new this.$db.EquipmentWorksheet({id: this.form.id}).downloadEndpoint
                this.loading = true
                await this.downloadFile(downloadEndpoint)
                    .catch((e) => {
                        this.showError(e.toString())
                    })
                await this.loadResource()
                this.loading = false
            }
        }
    };
</script>
